<template>
  <v-flex>
    <v-card class="rounded-card elevation-3">
      <div class="wrapper" id="mapDiv">
        <GmapMap
          ref="mapRef"
          :center="center"
          :zoom="14"
          class="mapCircle"
          v-bind:style="{'width': '100%', 'height': height + 'px'}"
          :options="{
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: true,
                            disableDefaultUi: false
                          }"
        >
          <GmapMarker
            :key="index"
            v-for="(m, index) in markers"
            :position="m.position"
            :icon="m.icon"
            :clickable="false"
            :draggable="false"
            @click="center=m.position"
          />
        </GmapMap>
        <i class="top"></i>
        <i class="right"></i>
        <i class="bottom"></i>
        <i class="left"></i>
        <i class="top left"></i>
        <i class="top right"></i>
        <i class="bottom left"></i>
        <i class="bottom right"></i>
      </div>
    </v-card>
  </v-flex>
</template>

<script>
import { gmapApi } from "vue2-google-maps";

global.jQuery = require("jquery");
var $ = global.jQuery;
window.$ = $;

export default {
  name: "AreaPolygonMap",
  props: {
    height: {
      type: Number,
      default: 500
    }
  },
  data: function() {
    return {
      booking: {},
      markers: [],
      center: this.$store.state.center,
      panned: false,
      token: ""
    };
  },
  mounted: function() {
    this.$refs.mapRef.$mapPromise.then(map => {
      this.map = map;
    });
  },
  computed: {
    google: gmapApi
  },
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
// p {
//   margin: 0px !important;
//   margin-bottom: 4px !important;
// }
</style>
